<template>
    <div>
        <visualizadorestoque :idproduto="idprodutoestoque" :descricao="descproestoque"></visualizadorestoque>
        <!-- Modal para visualizar detalhes do pedido -->
        <div class="modal fade" id="mddetalhespedido" tabindex="-1" aria-labelledby="mdldetalhespedido" aria-hidden="true" style="z-index: 1051;">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdldetalhespedido"><i class="fa fa-info-circle"></i> Detalhes do pedido/venda</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="padding: 10px 0px 10px 0px;">
                        <div class="container-fluid" v-show="mostrar">
                            <div class="row">
                                <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label for="edclientepeddet">Cliente:</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" id="edclientepeddet" v-bind:value="detpedido.idcliente+' - '+detpedido.nomecliente"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label for="edfilialdet">Filial:</label>
                                    <input type="text" class="form-control form-control-sm" id="edfilialdet" v-bind:value="detpedido.idfilial+' - '+detpedido.fantasia"
                                        data-bv-group=".group" disabled/>
                                </div>							
                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="ednrpeddet">Nr. Pedido:</label>
                                    <input type="text" class="form-control form-control-sm text-right font-weight-bold text-secondary" id="ednrpeddet" v-bind:value="mtdformatarzeros(detpedido.id, 8)"
                                        data-bv-group=".group" disabled/>
                                        <span v-if="parseInt(detpedido.entregaexterna) === 1" class="badge badge-primary badge-pill" style="background-color: #5A956A; font-size: 16px; position: absolute; top: 25px; left: 20px;" title="Entrega externa"><i class="fa fa-truck" style="transform: scale(-1, 1);"></i></span>
                                        <span v-if="parseInt(detpedido.origem) === 5" class="badge badge-primary badge-pill" style="background-color: #2f3c48; font-size: 16px; position: absolute; top: 25px; left: 60px; width: 35px;" title="Origem App"><i class="fa fa-tablet"></i></span>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="eddtemissaodet">Emissão:</label>
                                    <input type="text" class="form-control form-control-sm text-right" id="eddtemissaodet" v-model="detpedido.dtregistro"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label for="edplanodet">Plano de pagamento:</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" id="edplanodet" v-model="detpedido.descplano"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="edtotalpedidodet">Descontos:</label>
                                    <money type="text" class="form-control form-control-sm input-money" id="edtotalpedidodet" 
                                        v-model="detpedido.totaldesconto" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;" disabled>
                                    </money>                                
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="edtotalpedidodet">Acrescimos:</label>
                                    <money type="text" class="form-control form-control-sm input-money" id="edtotalpedidodet" 
                                        v-model="detpedido.totalacrescimo" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;" disabled>
                                    </money>                                
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="edtotalpedidodet">Total pedido:</label>
                                    <money type="text" class="form-control form-control-sm input-money" id="edtotalpedidodet" 
                                        v-model="detpedido.totalgeral" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;" disabled>
                                    </money>                                
                                </div>
                                <div style="padding-top: 20px;" class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <template v-if="parseInt(detpedido.tipo) === 0">
										<span class="badge badge-primary btn-block badge-pill" style="background-color: #6BA2D0; padding: 10px;">PEDIDO</span>
                                    </template>
                                    <template v-else-if="parseInt(detpedido.tipo) === 1">
                                        <span class="badge badge-primary btn-block badge-pill" style="background-color: #EEA435; padding: 10px;">ORÇAMENTO</span>
                                    </template>
                                    <template v-else-if="parseInt(detpedido.tipo) === 2">
                                        <span class="badge badge-primary btn-block badge-pill" style="background-color: #A42F11; padding: 10px;">O. S.</span>
                                    </template>										
                                    <template v-else>
                                        <span class="badge badge-primary btn-block badge-pill" style="background-color: #74A82A; padding: 10px;">CASHBACK</span>
                                    </template>                                     
                                </div>
                                <div style="padding-top: 20px;" class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <template v-if="parseInt(detpedido.stpedido) === 0">
                                        <span style="padding: 10px;" class="badge badge-primary btn-block badge-pill">ABERTO</span>
                                    </template>
                                    <template v-else-if="parseInt(detpedido.stpedido) === 1">
                                        <span  class="badge badge-secondary btn-block badge-pill" style="background-color: #5A956A; padding: 10px">FATURADO</span>
                                    </template>
                                    <template v-else>
                                        <span style="padding: 10px;" class="badge badge-danger btn-block badge-pill">CANCELADO</span>
                                    </template>										                             
                                </div>
                                <div style="padding-top: 20px;" class="col-sm-12 col-md-12 col-lg-1 col-xl-1">
                                    <span class="badge badge-primary btn-block badge-pill" style="background-color: #6BA2D0; padding: 10px; cursor: pointer;" @click.prevent="mtdimprimircomimagem(detpedido.id)" ><i style="font-size: 14px;" class="fa fa-link"></i></span>
                                </div>
                                <div v-show="parseInt(detpedido.idguiarota) > 0" class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="edguiarotadet">Guia Rota:</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" id="edguiarotadet" v-bind:value="mtdformatarzeros(detpedido.idguiarota, 8)"
                                        data-bv-group=".group" disabled/>
                                    <span v-if="parseInt(detpedido.efetivadaguia) === 1" class="badge badge-primary badge-pill bdg-det-icone-guia" style="background-color: #5A956A; font-size: 16px;" title="Efetivada"><i class="fa fa-check"></i></span>
                                    <span v-else-if="parseInt(detpedido.situacaoguia) === 0" class="badge badge-primary badge-pill bdg-det-icone-guia" style="background-color: #EEA435; font-size: 16px;" title="Em digitação"><i class="fa fa-keyboard-o"></i></span>
                                    <span v-else class="badge badge-primary badge-pill bdg-det-icone-guia" style="background-color: #6BA2D0; font-size: 16px;" title="Em rota"><i class="fa fa-truck"></i></span>
                                </div>                                
                            </div>
                            <div class="row" style="margin-top: 10px;">
                                <div class="col-lg-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link nav-link-ped active" data-toggle="tab" href="#dvprodutoscmp">Produtos</a>
                                        </li>
                                        <li v-show="parseInt(detpedido.tipo) > 0" class="nav-item">
                                            <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvservicoscmp">Serviços</a>
                                        </li>									
                                        <li v-show="parseInt(detpedido.tipo) === 2" class="nav-item">
                                            <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvinformacoesoscmp">Informações da O.S</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvobservacoescmp">Observações</a>
                                        </li>									
                                        <li v-show="parseInt(detpedido.tipo) === 2" class="nav-item">
                                            <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvimagenspedcmp">Imagens</a>
                                        </li>																											
                                        <li v-show="lsthistoricostoperacional.length > 0" class="nav-item">
                                            <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvhistoricostoscmp"> Histórico St. operacional</a>
                                        </li>																											
                                    </ul>
                                    <div class="tab-content border-left border-right border-bottom">
                                        <div id="dvprodutoscmp" class="container-fluid tab-pane active">
                                            <div class="row" style="padding: 0px 15px 0px 15px;">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm table-hover" style="margin-top: 15px">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th width="30">Item:</th>
                                                            <th width="100">Codigo:</th>
                                                            <th width="300">Descrição:</th>
                                                            <th width="100">Referência:</th>
                                                            <th width="40">Und:</th>
                                                            <th width="40">Marca:</th>
                                                            <th width="100">Vl. Unitário:</th>
                                                            <th width="50">Qtd:</th>     
                                                            <th v-show="rotinacorte && parseInt(detpedido.stpedido) === 0"></th>                                       
                                                            <th width="100">Desc/acres:</th>
                                                            <th width="100">Vl. Total:</th>
                                                            <th width="100">Local.:</th>
                                                            <th width="100">Estoque:</th>                                                
                                                            <th v-if="parseInt(detpedido.entregaexterna) === 1" width="100">Entregue:</th>                                                
                                                            <th v-if="parseInt(detpedido.entregaexterna) === 1" width="100">Resta:</th>                                                
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in detpedido.itens" v-bind:key="index" style="font-size: 12px;">
                                                                <td class="text-center">{{item.item}}</td>
                                                                <td>{{item.coddig}}</td>
                                                                <td>{{item.descproduto}}</td>
                                                                <td>{{item.referencia}}</td>
                                                                <td>{{item.unditem}}</td>
                                                                <td>{{item.descmarca}}</td>
                                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario), 2)}}</td>
                                                                <td style="text-align: right;">{{item.qtditem}}</td>
                                                                <td v-show="rotinacorte && parseInt(detpedido.stpedido) === 0" class="text-center">
                                                                    <button type="button" class="btn btn-danger btn-sm btncortaritem" @click.prevent="mtdrotinacorteitem(item)" title="Cortar item"><i class="fa fa-scissors"></i></button>
                                                                </td>					                                                    
                                                                
                                                                <template v-if="parseFloat(item.valordescacres) > 0">
                                                                    <template v-if="parseInt(item.descacres) === 0">
                                                                        <td v-if="parseInt(item.tipodescacres) === 0" style="text-align: right;"> - {{mtdformatavalordecimal(parseFloat(item.vlunitario) * parseFloat(item.qtditem) * parseFloat(item.valordescacres) / 100 , 2)}}</td>                                                
                                                                        <td v-else style="text-align: right;"> - {{mtdformatavalordecimal(parseFloat(item.valordescacres), 2)}}</td>                                                
                                                                    </template>
                                                                    <template v-else>
                                                                        <td v-if="parseInt(item.tipodescacres) === 0" style="text-align: right;"> + {{mtdformatavalordecimal(parseFloat(item.vlunitario) * parseFloat(item.qtditem) * parseFloat(item.valordescacres) / 100 , 2)}}</td>                                                
                                                                        <td v-else style="text-align: right;"> + {{mtdformatavalordecimal(parseFloat(item.valordescacres), 2)}}</td>    
                                                                    </template>
                                                                </template>

                                                                <template v-else>
                                                                    <td></td>
                                                                </template>
                                                                <td style="text-align: right; font-weight: 500;">
                                                                    <i v-show="parseFloat(item.vltotalimposto) > 0" class="fa fa-info-circle text-black-50" v-bind:title="'Imposto do item: R$ '+ mtdformatavalordecimal(parseFloat(item.vltotalimposto), 2)" style="font-size: 18px; float: left;"></i>
                                                                    {{mtdformatavalordecimal(parseFloat(item.vltotal), 2)}}
                                                                </td>
                                                                <td>{{item.localizacao}}</td>
                                                                <td>{{item.descestoque}} <i @click.prevent="mtdvisualizarestoque(item.coddig, item.descproduto)" class="fa fa-info-circle icon-detalhes" title="Vizualizar estoque"></i></td>
                                                                <td v-if="parseInt(detpedido.entregaexterna) === 1">{{item.qtdentregue}}</td>
                                                                <td v-if="parseInt(detpedido.entregaexterna) === 1">{{parseFloat(item.qtdentregar) - parseFloat(item.qtdentregue)}}</td>
                                                            </tr>
                                                        </tbody>                                        
                                                    </table>
                                                </div>                                                
                                            </div>
                                        </div>
                                        <div id="dvservicoscmp" class="container-fluid tab-pane">
                                            <div class="row" style="padding: 0px 15px 0px 15px;">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm table-hover" style="margin-top: 15px">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th width="50">Código:</th>
                                                            <th width="300">Descrição do serviço:</th>
                                                            <th width="100">Técnico:</th>
                                                            <th width="100">Vl. Unitário:</th>
                                                            <th width="50">Qtd:</th>     
                                                            <th width="100">Vl. Total:</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in detpedido.servicos" v-bind:key="index" style="font-size: 12px;">
                                                                <td>{{item.idservico}}</td>
                                                                <td>{{item.descservico}}</td>
                                                                <td>{{item.nometecnico}}</td>
                                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlservico), 2)}}</td>
                                                                <td style="text-align: right;">{{item.qtdservico}}</td>
                                                                <td style="text-align: right; font-weight: 500;">
                                                                    {{mtdformatavalordecimal(parseFloat(item.vltotal), 2)}}
                                                                </td>
                                                            </tr>
                                                        </tbody>                                        
                                                    </table>
                                                </div>                                                
                                            </div>                                            
                                        </div>
                                        <div id="dvinformacoesoscmp" class="container-fluid tab-pane">
										    <div class="row" style="padding-top: 15px; padding-bottom: 15px;">                                        
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                                                    <div class="row">
                                                        <div class="col-sm-12 col-md-5 col-lg-5">
                                                            <label for="edobjetooscmp">Objeto:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edobjetooscmp" v-model="detpedido.objeto" disabled data-bv-group=".group" maxlength="20">
                                                        </div>																						
                                                        <div class="col-sm-12 col-md-3 col-lg-3">
                                                            <label for="edidentificadoroscmp">Identificador:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edidentificadoroscmp" v-model="detpedido.identificador" disabled data-bv-group=".group" maxlength="20">
                                                        </div>											
                                                        <div class="col-sm-12 col-md-3 col-lg-3">
                                                            <label for="edmarcacaooscmp">Marcação:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edmarcacaooscmp" v-model="detpedido.marcacao" disabled data-bv-group=".group" maxlength="20">
                                                        </div>
                                                        <div class="col-sm-12 col-md-3 col-lg-3">
                                                            <label for="ednrserieoscmp">Número de série:</label>
                                                            <input type="text" class="form-control form-control-sm" id="ednrserieoscmp" v-model="detpedido.nrserie" disabled data-bv-group=".group" maxlength="20">
                                                        </div>
                                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                                            <label for="edmarcaoscmp">Marca:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edmarcaoscmp" v-model="detpedido.marca" disabled data-bv-group=".group" maxlength="20">
                                                        </div>
                                                        <div class="col-sm-12 col-md-5 col-lg-5">
                                                            <label for="edmodelooscmp">Modelo:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edmodelooscmp" v-model="detpedido.modelo" disabled data-bv-group=".group" maxlength="20">
                                                        </div>
                                                        <div class="col-sm-12 col-md-12 col-lg-12">
                                                            <label for="eddefeitoapresentadooscmp">Defeito apresentado:</label>
                                                            <input type="text" class="form-control form-control-sm" id="eddefeitoapresentadooscmp" v-model="detpedido.defeitoapresentado" disabled data-bv-group=".group" maxlength="100">
                                                        </div>
                                                        <div class="col-sm-12 col-md-12 col-lg-12">
                                                            <label for="edacessoriososcmp">Acessórios:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edacessoriososcmp" v-model="detpedido.acessorios" disabled data-bv-group=".group" maxlength="100">
                                                        </div>
                                                        <div class="col-sm-12 col-md-8 col-lg-8">
                                                            <label for="edoutrasinformacoesoscmp">Outras informações:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edoutrasinformacoesoscmp" v-model="detpedido.outrasinformacoes" disabled data-bv-group=".group" maxlength="100">
                                                        </div>                     
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                                                    <div class="row">
                                                        <div class="col-md-12" style="margin-top: 15px;">
                                                            <ul class="list-group">
                                                                <li class="list-group-item text-center text-black-50" style="padding: 5px;">
                                                                    <span style="font-size: 16px; font-weight: 600;">CHECKLIST</span>
                                                                    <i v-show="opcrud < 3" class="fa fa-th-list" id="btmarcartodaschecklist" @click.prevent="mtdmarcartodaschecklist()" data-toggle="tooltip" title="Marcar/Desmarcar todas"></i>
                                                                </li>
                                                                <div style="height: 228px; overflow-y: auto;">
                                                                    <li v-for="(checkitem, index) in detpedido.checklist" v-bind:key="index" class="list-group-item d-flex justify-content-between align-items-center item-op-usuario" style="padding: 10px 15px 10px 15px;">
                                                                        <span class="menuprincipal">{{ checkitem.descricao }}</span>
                                                                        <span v-if="parseInt(checkitem.habilita) === 0"><i class="fa fa-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold;"></i></span>
                                                                        <span v-else><i class="fa fa-check-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold;"></i></span>
                                                                    </li>
                                                                </div>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>                                                                                                
                                            </div>
                                        </div>							
                                        <div id="dvobservacoescmp" class="container-fluid tab-pane">
                                            <div class="row" style="padding-top: 15px; padding-bottom: 15px;">
                                                <div class="col-sm-12">
                                                    <div class="float-right">
                                                        <span><i class="fa fa-pencil-square-o" @click.prevent="mtdeditarobs(detpedido.observacoes)" style="font-size:18px; cursor: pointer; color: rgba(0,0,0,.65); font-weight: bold;"></i></span>
                                                    </div>
                                                </div>	
                                                <div class="col-sm-12">
                                                    <textarea class="form-control center" rows="5" id="txtobservacoes" v-model="detpedido.observacoes" v-bind:disabled="habcampo"></textarea>
                                                </div>		
                                                <template v-if="mostrarbtn">
                                                    <div style="padding-top: 2%;" class="col-sm-12">
                                                        <div class="float-right">
                                                            <button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmaraltobs(detpedido.observacoes, detpedido.id)"><i class="fa fa-check"></i> Confirmar</button>
                                                            <button type="button" class="btn btn-secondary btn-sm" @click.prevent="mtdcancelaraltobs()" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
                                                        </div>
                                                    </div>   
                                                </template>
                                            </div>
                                        </div>                                        
                                        <div id="dvhistoricostoscmp" class="container-fluid tab-pane">
                                            <div class="row" style="height: 250px !important; overflow-y: scroll;" v-if="myloader == false">
                                                <div class="col-12 mt-2" v-for="(item, indice) in lsthistoricostoperacional" :key="indice">
                                                    <div class="table-historicostos">
                                                        <span style="color: #6c757d !important; margin-right: 5px;">{{ item.datahora }}  </span>
                                                        <span style="font-weight: bold;">Usuário: </span><span style="color: #6c757d !important; margin-right: 5px;">{{ item.nomeusu }}</span><br>
                                                        <span style="margin-right: 5px;"> Situação operacional atualizada:</span>
                                                        <span style="margin-right: 5px;" class="badge badge-info">{{ item.descricao }}</span>
                                                    </div>
                                                    <hr/>
                                                </div>
                                            </div>
                                            <div class="row" style="justify-content: center; height: 200px" v-if="myloader == true">
                                                <div class="myloader">
                                                </div>
                                            </div>
                                        </div>                                        
                                        <div id="dvimagenspedcmp" class="container-fluid tab-pane">
                                            <div class="row" style="padding: 15px;">
                                                <div class="col-md-12 border rounded" style="padding-top: 15px;">
                                                    <div v-if="detpedido.imagens.length > 0" class="row">
                                                        <div v-for="(imagem, index) in detpedido.imagens" v-bind:key="index" class="col-md-2 text-center" style="margin-bottom: 15px;">                                            
                                                            <img class="img-thumbnail img-produto" v-bind:src="pathimgview+imagem.patharquivo">                                                  
                                                        </div>
                                                    </div>
                                                    <div v-else class="row">
                                                        <div class="col-md-12 text-center">
                                                            <h6 style="font-size: 12px; padding-bottom: 5px;">Sem imagens para visualização</h6>
                                                        </div>
                                                    </div>
                                                    <div v-show="mtdverificaop('020Z.010Z.270Z')"  class="col-md-12 text-center" style="margin-top: 15px; margin-bottom: 15px;">
                                                        <input
                                                            type="file"
                                                            id="ipselecionarimgcmp"
                                                            accept="image/png, image/jpeg"
                                                            @change="mtdselecionarimagem"
                                                            style="display: none;"
                                                            ref="if_imgprodutocmp">
                                                        <button type="button" @click="$refs.if_imgprodutocmp.click()" class="btn btn-primary btn-sm"><i class="fa fa-picture-o"></i> Adicionar imagem</button>
                                                    </div>
                                                </div>
                                            </div>
									    </div>
                                    </div>
                                </div>
                            </div>							
                            <div class="row" style="margin-top: 10px;">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                    <label for="edresponsaveloscmp">Responsável:</label>
                                    <input type="text" class="form-control form-control-sm" id="edresponsaveloscmp" v-model="detpedido.responsavel" disabled data-bv-group=".group" maxlength="20">
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                    <label for="edfonecmp">Fone:</label>
                                    <input type="text" v-model="detpedido.fone" disabled
                                        class="form-control form-control-sm" id="edfone" 
                                        v-mask="['(##) ####-####', '(##) #####-####']">
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                    <label for="eddtretornocmp">Dt. Retorno:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtretornocmp" v-model="detpedido.dtretorno" :config="options"
                                            class="form-control form-control-sm" disabled></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>										
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-3 col-lg-3">
                                    <label for="edstoscmp">St. Operacional: 
                                    <i v-show="opalterastop == 0" class="fa fa-pencil-square-o" @click.prevent="mtdalterastoperacional(detpedido.descstos, detpedido.stpedido )" style="font-size:18px; cursor: pointer; color: rgba(0,0,0,.65); font-weight: bold;" data-toggle="tooltip" data-placement="top" title=""></i>
                                    <i v-show="opalterastop > 0" class="fa fa-check-square-o"  @click.prevent="mtdconfirmaalteracaostop(detpedido.descstos, detpedido.idstos, detpedido.id)" style="background-color: transparent; font-size:18px; cursor: pointer; color: rgba(0,0,0,.65); font-weight: bold; margin-right: 5px;" data-toggle="tooltip" data-placement="top" title="Confirmar"></i>
                                    <i v-show="opalterastop > 0" class="fa fa-times-circle-o"  @click.prevent="mtdcancelaalteracaostop(detpedido.descstos, detpedido.idstos)" style="font-size:18px; cursor: pointer; color: rgba(0,0,0,.65); font-weight: bold;" data-toggle="tooltip" data-placement="top" title="Cancelar"></i></label>
                                    <select id="cbstoscmp" data-placeholder="Selecione uma situação" v-model="vidstos" data-allow-clear="true" style="width:100%;" :disabled="opalterastop == 0"></select>
                                </div>                                                                   	
                                <div v-if="parseInt(detpedido.stpedido)!==0 && parseInt(detpedido.stpedido)!== 1" class="col-12">
                                    <label for="txtmotivocancelamento">Motivo do cancelamento:</label>
                                    <textarea class="form-control center" rows="3" id="txtmotivocancelamento" v-model="detpedido.motivocancelamento" disabled></textarea>
                                </div>																							
                            </div>									                            
                        </div>
					</div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" @click.prevent="resetaobs()" data-dismiss="modal" style="width: 150px;"><i class="fa fa-sign-out"></i> Sair</button>
                    </div>					
				</div>
			</div>
		</div>

		<!-- Modal para corte do item -->
		<div class="modal fade" id="mdcorteitemcmp" tabindex="-1" style="z-index: 1052;">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-scissors"></i> Corte do item</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<label for="editemcortecmp">Item:</label>
							<input type="text" style="font-size: 10px; font-weight: bold;" class="form-control form-control-sm" id="editemcortecmp" :value="itemcortar.idproduto +' - '+itemcortar.descproduto" data-bv-group=".group" disabled>
						</div>													
						<div class="col-12">
							<label for="edqtditemcortarcmp">*Qtd. corte:</label>
							<money type="text" class="form-control form-control-sm" id="edqtditemcortarcmp" v-model="qtditemcortar" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
						</div>						
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmarcorteitem()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>				        
			</div>
			</div>
		</div>        
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
import VisualizadorEstoque from '../components/cmpconsultaestoquepro2'
export default {
    name: 'cmpdetalhespedido',
    props:[
                'idpedido',
                'rotinacorte'
          ],

    components: {
        'visualizadorestoque'   : VisualizadorEstoque
    },          
    data: function() {
        return {
            detpedido           : {
                pathimagens: '',
                itens      : [],
                servicos   : [],
                imagens    : [],
                checklist  : []                                
            },
            mostrar             : false,
            arqimgselecionado    : null,

            //pega o path do diretorio padrão das imagens
            pathimgview          : this.$store.state.configpaths.pathimagens,		
            
            habcampo    : true, // habilitar edição de obcervações 
            mostrarbtn  : false,
            vobsold     : '',

              //id do produto para visualização
            idprodutoestoque    : 0,
            descproestoque      : '',

            lsthistoricostoperacional : [],

            //variáis do item a ser cortado
            itemcortar			: [],
            qtditemcortar		: 1,
            vidstos             : null,
            opalterastop        : 0,  
            descstos            : '',
            myloader            : false,

            money				: {
                decimal         : ',',
                thousands       : '.',
                prefix          : '',//aqui colocar o cifrão se for necessário
                precision       : 2,
                masked          : false
            }            
        };
    },
    methods: {
        mtdverificaop(op){
            return util.opcaousuario(op, this.$store.state.perfilusuario);
        },
        mtdselecionarimagem(event){
            let vself = this;
            let loader      = vself.$loading.show();
            vself.arqimgselecionado = event.target.files[0];
            let localsalvar = vself.$store.state.configpaths.pathimgpedidos + vself.$store.state.filialpadrao.idcliente +'/'+ vself.detpedido.pathimagens;
            let extarquivo = vself.arqimgselecionado.name.split('.').pop()
            let nomearquivo = '1.' + extarquivo;

            // Explicação do que ta acontecendo aqui abaixo...
            // Caso os arquivos não estajam ainda sendo salvos com uma ordem de números, para que seja possível ordenar,
            // vai ser gerado um número aleatório para que a ordenação não quebre.
            // Mas o upload das imagens ja esteja sendo feito com o nome dos arquivos numerados, funciona normalmente. - Rodrigo
            // valeu furry - Guga
            let imagens = vself.detpedido.imagens;
            if(imagens.length > 0){
                if (isNaN(parseInt(imagens.pop().arquivo.split('.')[0]))){
                    nomearquivo = Math.floor(Math.random() * 1000000) + '.' + extarquivo;
                } else {
                    nomearquivo = (parseInt(imagens.pop().arquivo.split('.')[0]) + 1) + '.' + extarquivo;
                }
            }
            let parametros      = [
                {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                {parametro: 'localsalvar',      valor  : localsalvar},
                {parametro: 'nomearquivo',      valor  : nomearquivo},
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
            retorno.then(function (response) {
                if ($.isNumeric(response.data.inf)){
                    vself.$toastr.s('Imagem enviada com sucesso!', 'Informação!');
                    vself.detpedido.imagens = [];
                    vself.detpedido.imagens = vself.mtdordenaimagens(response.data.arquivos);
                    console.log(vself.detpedido.imagens);
                    vself.arqimgselecionado = null;
                    $('#ipselecionarimgcmp').val('');

                }else{
                    vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                }
                loader.hide();
            }).catch(function (response) {
                loader.hide();
                vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
            });

        },
        mtdordenaimagens(lstimagens){
            let lstordenada = lstimagens.sort((a, b) => {
                if (a.arquivo < b.arquivo) {
                    return -1;
                }
                if (a.arquivo > b.arquivo) {
                    return 1;
                }
                return 0;
            });
            return lstordenada;
        },
        mtdvisualizarestoque(codigo, desc){
            this.idprodutoestoque = codigo;
            this.descproestoque   = desc;
            $('#mdestoqueproduto2').modal('show');
        },
        mtdimprimircomimagem(idpedido){
            window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirpedido.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&tpimp=0&idu='+
							this.$store.state.usuario.id+'&imgos=1', '_blank');	
        },
        resetaobs(){
            this.habcampo   = true;
            this.mostrarbtn = false;
            this.vobsold    = '';
        },
        mtdconfirmaraltobs(obs, idobs){
                let vself       = this;
                let loader      = vself.$loading.show();
                let parametros  = [

                    {parametro: 'op',               valor       : 'mudarobs'},
                    {parametro: 'idclientesac',     valor       : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'obs',              valor       : obs},
                    {parametro: 'obsold',           valor       : vself.vobsold},
                    {parametro: 'idobs',            valor       : idobs},
                    {parametro: 'idfilial',         valor       : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor       : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor       : '020Z.010Z.200Z'},

                ];

                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();                
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Alterado com sucesso!', 'Informação!')
                        vself.habcampo   = true;
                        vself.mostrarbtn = false;
                        vself.vobsold    = '';
                    }else{
                        let tpret = response.data.substring(0,1)
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!')
                                break
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!')
                                break
                        }

                        vself.mtdcancelaraltobs();
                    }          
                }).catch(function (response) {
                    loader.hide();
                });
        },
        mtdcancelaraltobs(){
            this.habcampo = true
            this.mostrarbtn = false
            this.detpedido.observacoes = this.vobsold;
            this.vobsold = '';
        },
        mtdeditarobs(obs){
            if (!util.opcaousuario('020Z.010Z.200Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {
                this.vobsold = obs;
                this.habcampo = false;
                this.mostrarbtn = true;
                setTimeout(() => {
                    $('#txtobservacoes').focus();
                }, 300);
            }
           
        },
        mtdalterastoperacional(){
            if (!util.opcaousuario('020Z.010Z.291Z', this.$store.state.perfilusuario)){
				this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {
                this.opalterastop = 1;
                $('#txtobservacoes').focus();
            }
        },
        mtdcancelaalteracaostop(descstos, idstos){
            this.opalterastop = 0;
            var defstos  = new Option(descstos, idstos, true, true);
            $('#cbstoscmp').append(defstos).trigger('change');
            
        },
        mtdconfirmaalteracaostop(descstos, idstos, idpedido){
            let vself       = this;
            this.opalterastop = 1;


            $.confirm({
                title: 'Confirmação!',
                content: 'Atualizar situação operacional?',
                icon: 'fa fa-question-circle',
                escapeKey: true,
                backgroundDismiss: false,
                escapeKey: 'nao',
                type: 'dark',
                typeAnimated: true,
                buttons: {
                sim: {
                    text: '<u>S</u>im',
                    keys: ['s', 'S'],
                    btnClass: 'btn-blue',
                    action: function () {        
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',               valor       : 'alterastoperacionalpedido'},
                            {parametro: 'idclientesac',     valor       : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'idusuario',        valor       : vself.$store.state.usuario.id},
                            {parametro: 'idfilial',         valor       : vself.$store.state.filialpadrao.codfil},
                            {parametro: 'descstos',         valor       : vself.descstos.text ? vself.descstos.text : ""},
                            {parametro: 'idstos',           valor       : vself.vidstos},
                            {parametro: 'idpedidovenda',    valor       : idpedido},
                            {parametro: 'descstosatual',    valor       : descstos},
                            {parametro: 'idstosatual',    valor         : idstos},
                            // {parametro: 'codop',            valor       : '020Z.010Z.200Z'},
                        ];

                        let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                        retorno.then(function (response) {
                            loader.hide();                
                            if ($.isNumeric(response.data)){
                                vself.$toastr.s('Alterado com sucesso!', 'Informação!');
                                vself.mtdcarregahistoricostos();
                                vself.opalterastop = 0;
                            }else{
                                let tpret = response.data.substring(0,1)
                                switch (tpret) {
                                    case 'I':
                                        vself.$toastr.w(response.data.substring(4), 'Atenção!')
                                        break
                                    case 'E': default:
                                        vself.$toastr.e(response.data.substring(4), 'Erro!')
                                        break
                                }
                                vself.mtdcancelaalteracaostop();
                            }          
                        }).catch(function (response) {
                            loader.hide();
                        });
                    },
                },
                nao: {
                    text: '<u>N</u>ão',
                    keys: ['n', 'N'],
                    action: function () {
                    }
                }
                }
            });	
        },
        mtdformatavalordecimal(valor, digitos){
            return util.formatavalordecimais(valor, digitos);
        },
        mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
		},        
        mtdlocalizarpedido(){
            let vself       = this;
            if (vself.idpedido !== ''){                
                let loader      = vself.$loading.show();
                let filtro      = ' and p.id='+vself.idpedido;
                let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'diretorioimagens', valor   : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'idclientesac', valor       : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor       : filtro},
                        {parametro: 'limit',        valor       : 1},
                        {parametro: 'offset',       valor       : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                    retorno.then(function (response) {
                    vself.mtdcarregahistoricostos();
                    if (response.data.pedidos.length > 0){
                        vself.mostrar   = true;
                    }
                    vself.detpedido = response.data.pedidos[0];
                    vself.detpedido.imagens = vself.mtdordenaimagens(vself.detpedido.imagens);
                    vself.vidstos = vself.detpedido.idstos;
                    if (vself.detpedido.idstos == 0){
                        this.vidstos = null;
                        $("#cbstoscmp").val(null).trigger('change');
                    }else{
                        var defstos  = new Option(vself.detpedido.descstos, vself.detpedido.idstos, true, true);
                        $('#cbstoscmp').append(defstos).trigger('change');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                });
            }
        },
        mtdcarregahistoricostos(){
            let vself       = this;
            if (vself.idpedido !== ''){                
                vself.myloader = true;
                let parametros  = [
                        {parametro: 'op',           valor       : 'listagemstos'},
                        {parametro: 'idclientesac', valor       : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'idusuario',    valor       : vself.$store.state.usuario.id},
                        {parametro: 'idpedido',     valor       : vself.idpedido},
                    ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    // console.log(response.data);
                    vself.lsthistoricostoperacional = [];
                    vself.lsthistoricostoperacional = response.data;
                    vself.myloader = false;
                }).catch(function (response) {
                    vself.myloader = false;
                });
            }
        },
        mtdrotinacorteitem(item){
            this.itemcortar 	= JSON.parse(JSON.stringify(item));
            this.qtditemcortar  = this.itemcortar.qtditem;
            $('#mdcorteitemcmp').modal('show');
        },
        mtdconfirmarcorteitem(){
            let vself = this;
            if (parseFloat(vself.qtditemcortar) <= 0){
                vself.$toastr.w('Quantidade inválida!', 'Atenção!');
                $('#edqtditemcortarcmp').focus();
                return;
            }
            if (parseInt(vself.itemcortar.fracionado) === 0){
                if (!Number.isInteger(vself.qtditemcortar)){
                    vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                    $('#edqtditemcortarcmp').focus();
                    return;
                }
            }				
            if (parseFloat(vself.qtditemcortar) > parseFloat(vself.itemcortar.qtditem)){
                vself.$toastr.w('Quantidade de corte não pode ser maior que a quantidade do item!', 'Atenção!');
                $('#edqtditemcortarcmp').focus();
                return;
            }				
            $.confirm({
                title: 'Confirmação!',
                content: 'Confirma corte do item?',
                icon: 'fa fa-question-circle',
                escapeKey: true,
                backgroundDismiss: false,
                escapeKey: 'nao',
                type: 'dark',
                typeAnimated: true,
                buttons: {
                sim: {
                    text: '<u>S</u>im',
                    keys: ['s', 'S'],
                    btnClass: 'btn-blue',
                    action: function () {        
                        vself.mtdgravarcortaritem();
                    },
                },
                nao: {
                    text: '<u>N</u>ão',
                    keys: ['n', 'N'],
                    action: function () {
                        $('#edqtditemcortarcmp').focus();
                    }
                }
                }
            });								
        },
        mtdgravarcortaritem(){
            let vself = this;
            let loader       = vself.$loading.show()
            let parametros   = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'cortaritem'},
                {parametro: 'qtdcorte',     valor : vself.qtditemcortar},
                {parametro: 'idpedido',     valor : vself.detpedido.id},
                {parametro: 'idproduto',    valor : vself.itemcortar.idproduto},
                {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                {parametro: 'codop',        valor : '020Z.010Z.034Z'},
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
            retorno.then(function (response) {
                loader.hide();
                if ($.isNumeric(response.data)){
                    vself.$toastr.s('Corte realizado com sucesso!', 'Informação!')
                    vself.mtdlocalizarpedido();
                    $('#mdcorteitemcmp').modal('hide');
                }else{
                    let tpret = response.data.substring(0,1)
                    switch (tpret) {
                        case 'I':
                            vself.$toastr.w(response.data.substring(4), 'Atenção!')
                            break
                        case 'E': default:
                            vself.$toastr.e(response.data.substring(4), 'Erro!')
                            break
                    }
                }
            }).catch(function (response) {
                loader.hide()
                vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!')
            });				
        },
        mtdselect2_def(){
            let vself = this;

            $("#cbstoscmp").select2({
                id: function (e) {return e.id},
                ajax: {
                    url: vself.$store.state.configpaths.pathselect2,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            idclientesac : vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbstos',
                            c1: 'id',
                            c2: 'descricao'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.vidstos = $("#cbstoscmp").val();
                vself.vidstos? vself.descstos = $("#cbstoscmp").select2("data")[0] : vself.descstos= "";
            });
        }
    },
    mounted: function() {
        let vself = this;
        
        $("#mddetalhespedido").on('show.bs.modal', function(){
            //console.log('Pedido: '+vself.idpedido);
            $('.nav-tabs a[href="#dvprodutoscmp"]').tab('show');
            setTimeout(() => {
                this.vidstos = null;
                $("#cbstoscmp").val(null).trigger('change');
                vself.mtdlocalizarpedido();
                vself.mtdselect2_def();
                $(function () {
                  $('[data-toggle="tooltip"]').tooltip()
                })
            }, 300);            
        });
        $("#mddetalhespedido").on('hide.bs.modal', function(){
            vself.idpedido       = '';
            vself.pathimagens    = '';
            vself.mostrar        = false;
            vself.detpedido      = [];
            vself.detpedido.itens    = [];
            vself.detpedido.servicos = [];
            vself.detpedido.imagens  = [];
            vself.detpedido.checklist= [];
            
            
        });

        $('#mdcorteitemcmp').on('shown.bs.modal', function (e) {
			$('#edqtditemcortarcmp').focus();
		});                                
    },    
    computed:{ 
    },
    watch: {
    }
}
</script>
<style>   
    .bdg-det-icone-guia{
        position: absolute;
        top: 25px;
        right: 18px;
    }
    .table-historicostos{
        width: 100%;
    }
    /* HTML: <div class="loader"></div> */
    .myloader{
        width:  40px;                 
        height: 40px;              
        margin: auto;              
        aspect-ratio: 1;
        --_c:no-repeat radial-gradient(farthest-side,#25b09b 92%,#0000);
        background: 
            var(--_c) top,
            var(--_c) left,
            var(--_c) right,
            var(--_c) bottom;
        background-size: 12px 12px;
        animation: l7 1s infinite;
    }
    @keyframes l7 {
        to{transform: rotate(.5turn)}
    }
</style>